export class AlgoliaApiGeneralError extends Error {}
